import gql from 'graphql-tag';

export const saveBill = gql`
  mutation saveBill($input: BillDtoInput) {
    saveBill(billDto: $input) {
      code
      status
      data {
        id
        controlNumber
        mrn
        payerName
        queueCode
        costSharingModeSubgroupId
      }
    }
  }
`;
